import { initialChatState, actions } from "./action";

export const chatReducer = (state = initialChatState, action) => {
    switch (action.type) {
        case actions.MESSAGE_GET_ALL_SUCCESS:
            return {
                ...state,
                totalRecords : action.payload?.header?.totalRecords,
                messageList: Array.isArray(action.payload.body) ? [...state.messageList, ...action.payload.body] : state.messageList
            };
        case actions.MESSAGE_RESET_SUCCESS:
            return {
                ...state,
                messageList: []
            };
        case actions.TOPIC_GET_SUCCESS:
            return {
                ...state,
                topic: action.payload
            };
        case actions.TOPIC_CREATE_SUCCESS:
            return {
                ...state,
                createdTopic: action.payload
            };
        case actions.TOPIC_RESET_SUCCESS:
            return {
                ...state,
                createdTopic: {}
            };
        default:
            return state;
    }
};
